import { useEffect } from 'react';

import { formLoaded } from '../../../modules/metrics';
import type { FormName } from '../../../types';

export default (name: FormName) => {
  useEffect(() => {
    formLoaded(name);
  }, [name]);
};
